import * as React from "react"
import { useAddressValidationRules } from "../../../hooks-saleor/useAdsressValidationsRules"
import LoadingSpinner from "../LoadingSpinner"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"
import Body from "../typography/Body"
import { HorizontalSpacer } from "../spacers"

import { captureExceptionWithContext } from "../../../utils/sentry"

interface Props {
  countryCode: string
  id?: string
  name?: string
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

const SelectStyle = styled.select`
  outline: none;
  width: 100%;
  font-family: "Karla", sans-serif;
  font-size: 20px;
  border-bottom: 1px solid black;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  color: ${(props) => props.theme.colors.greyDark};

  ::placeholder {
    color: ${(props) => props.theme.colors.greyPlaceholder};
    font-style: italic;
  }

  :disabled {
    background: transparent;
    color: ${(props) => props.theme.colors.greyDisabled};
  }

  ${MediaQuery.XS} {
    font-size: 14px;
  }
`

const AddressValidationRules: React.FC<Props> = ({ countryCode, id, name, onChange }) => {
  const { addressValidationRules, error, isLoading } = useAddressValidationRules(countryCode)

  if (error) {
    captureExceptionWithContext(error, "error fetching address validation rules")
  }

  return (
    <div>
      <HorizontalSpacer spacing={2} />

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {addressValidationRules?.requiredFields?.includes("countryArea") && (
            <div>
              <Body>Country area:</Body>
              <SelectStyle title="Country area" name={name} id={id} onChange={onChange} required>
                <option value={undefined}></option>
                {addressValidationRules?.countryAreaChoices?.map((option: { raw: string; verbose: string }) => (
                  <option value={option.raw} key={option.raw}>
                    {option.verbose}
                  </option>
                ))}
              </SelectStyle>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default AddressValidationRules
